import {
    faLineChart,
    faExternalLinkAlt,
    faCalendar,
    faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import SubMenuItem from "../../SubMenuItem/SubMenuItem";
import SubMenuTitle from "../../SubMenuTitle/SubMenuTitle";
import PortfolioContainer from "./Portfolio.styles";
const Portfolio = () => {
    const history = useHistory();

    return (
        <PortfolioContainer className={"submenu"}>
            <div className={"top"}>
                <h1>PORTFOLIO</h1>
                <hr />
                <SubMenuTitle
                    text={"PORTFOLIO MANAGER PACK"}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Portfolio Snapshot"}
                    active={history.location.pathname === "/portfolio/snapshot"}
                    icon={faLineChart}
                    click={() => history.push("/portfolio/snapshot")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"GEF Sectors"}
                    active={
                        history.location.pathname === "/portfolio/gef_sectors"
                    }
                    icon={faLineChart}
                    click={() => history.push("/portfolio/gef_sectors")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Dummy Portfolio"}
                    active={
                        history.location.pathname ===
                        "/portfolio/dummy-portfolio"
                    }
                    icon={faBriefcase}
                    click={() => history.push("/portfolio/dummy-portfolio")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Fair Value x Quality"}
                    active={
                        history.location.pathname ===
                        "/portfolio/quality-matrix"
                    }
                    icon={faLineChart}
                    click={() => history.push("/portfolio/quality-matrix")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Total return decomp."}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Total_Return_Decomposition",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Portfolio Valuation"}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Portfolio_Valuation",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Earnings growth decomp."}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Earnings_Growth_Decomp",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Manager Tracker"}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Manager_Tracker",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Discount rates"}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Discount_Rates",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuTitle
                    text={"ASIA"}
                    permissions={["p_bqmq_can_view_results"]}
                ></SubMenuTitle>
                <SubMenuItem
                    text={"Asia PL Dashboard"}
                    active={history.location.pathname === "/portfolio/asia_pl"}
                    icon={faLineChart}
                    click={() => history.push("/portfolio/asia_pl")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuTitle
                    text={"MORNING MEETINGS"}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Morning Meetings"}
                    active={history.location.pathname.includes(
                        "/morning-meetings"
                    )}
                    icon={faCalendar}
                    click={() => history.push("/portfolio/morning-meetings")}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuTitle
                    text={"HITS & MISSES"}
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Hits and Misses"}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Hits_and_Misses",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
                <SubMenuItem
                    text={"Bessembinder Focus List"}
                    active={false}
                    icon={faExternalLinkAlt}
                    click={() =>
                        window.open(
                            "https://web.datapilots.qs-projects.co.uk/Bessembinder_focus_list",
                            "_blank"
                        )
                    }
                    permissions={["p_bqmq_can_view_results"]}
                />
            </div>
        </PortfolioContainer>
    );
};
export default Portfolio;
